import { useEffect } from 'react'
import { useQuery } from '@apollo/client'
import { gql } from '~/__generated__'
import { getAccessToken } from './tokens'

const PING = gql(`
  query Ping {
    ping
  }
`)

export const usePing = () => {
  // console.log('usePing rerender getTimeToExpire', getTimeToExpire())

  const { data, refetch } = useQuery(PING, {
    fetchPolicy: 'network-only',
    pollInterval: 60000,
    skipPollAttempt: () => document.hidden || !getAccessToken(true),
  })

  useEffect(() => {
    const onFocus = () => {
      // console.log('token expire in', getTimeToExpire())
      refetch()
    }
    window.addEventListener('focus', onFocus)
    return () => window.removeEventListener('focus', onFocus)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return data?.ping
}
